import React from 'react';
import { ChevronDown } from 'lucide-react';
interface NativeSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: string[];
  label?: string;
}
export function NativeSelect({
  options,
  label,
  className = '',
  id,
  ...rest
}: NativeSelectProps) {
  return <div className={className} data-id="element-137" data-mp="2aq0vlph0hksq">
      {label && <label htmlFor={id} className="mb-1 block text-xs font-medium text-slate-600" data-id="element-138" data-mp="2aoz8unqmv9v6">{label}</label>}
      <div className="relative" data-id="element-139" data-mp="1e1co3n2x9fxk">
        <select id={id} {...rest} className="h-9 w-full appearance-none rounded-md border border-input bg-white pl-3 pr-8 text-sm text-navy-900 outline-none focus:border-navy-500 focus:ring-2 focus:ring-navy-100" data-id="element-140" data-mp="1e2e1vzbbogiz">
          {options.map(o => <option key={o} value={o} data-id="element-141" data-mp="1s1dq55uxatem">{o}</option>)}
        </select>
        <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-142" data-mp="2ygo349n0m8er" />
      </div>
    </div>;
}